// @ts-nocheck
import React from 'react';
import EventManagementTravel from '@/pages/admin/event-management/EventManagementTravel';

const DemoTravel: React.FC = () => {
  return <EventManagementTravel />;
};

export default DemoTravel;
